import styled from 'styled-components';

import Image from '@nubank/www-latam-commons/components/Image/Image';

export const StyledImage = styled(Image)`
  height: 24rem;
`;

StyledImage.displayName = 'StyledImage';
